import { serverTimestamp } from 'firebase/firestore';
import { randomInitialVibeAccuracy } from './vibeAccuracy';

/** Starter spin balance for a brand-new account. Existing users keep their stored balance. */
export const DEFAULT_USER_SPIN_BALANCE = 0;

/**
 * Canonical `users/{uid}` defaults for a brand-new account. Single source of truth
 * shared by every client signup path (email signup, spin-wheel lazy doc, OAuth
 * provisioning) so starter balances and profile fields can't drift between flows.
 * Mirror of the server helper in functions/index.js (`buildNewUserDoc`).
 */
function normalizeSignupEmail(email) {
  if (!email || typeof email !== 'string' || !email.includes('@')) return null;
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf('@');
  if (at <= 0 || at === trimmed.length - 1) return null;
  return trimmed;
}

export function buildNewUserDoc({
  email,
  signupSource,
  isEdu = false,
  eduEmail = null,
  matchFriendReferralFromFeed = null,
} = {}) {
  const notificationEmail = normalizeSignupEmail(email);
  return {
    email,
    ...(notificationEmail ? { notificationEmail } : {}),
    createdAt: new Date(),
    termsAcceptedAt: serverTimestamp(),
    signupSource,
    savedDateIdeas: [],
    foxesBalance: 55,
    spinBalance: DEFAULT_USER_SPIN_BALANCE,
    matcha: 0,
    accuracy: randomInitialVibeAccuracy(),
    // auraColor is assigned server-side (Cloud Function ensureMyAuraColor) so the
    // selection methodology never ships in the client bundle.
    cart: [],
    luvProfile: {
      preferences: [],
      savedPlaces: [],
      completedDates: [],
    },
    ...(matchFriendReferralFromFeed ? { matchFriendReferralFromFeed } : {}),
    ...(isEdu ? { berkeleyEmail: eduEmail || email, berkeleyEmailVerified: false } : {}),
  };
}
